export type ListType =
  | 'recommended'
  | 'category'
  | 'company'
  | 'tag'
  | 'sponsored'
  | 'ranking'
  | 'latest';

export const getActiveListTypeFromUrlPath = (urlPath: string): ListType => {
  if (urlPath.startsWith('/columns/category')) {
    return 'category';
  }
  if (urlPath.startsWith('/columns/companies')) {
    return 'company';
  }
  if (urlPath.startsWith('/columns/tags')) {
    return 'tag';
  }
  if (urlPath.startsWith('/columns/sponsored')) {
    return 'sponsored';
  }
  if (urlPath.startsWith('/columns/ranking')) {
    return 'ranking';
  }
  if (urlPath.startsWith('/columns/latest')) {
    return 'latest';
  }
  return 'recommended';
};
